import $ from "jquery";
import MoreInfoModal from "../modal/MoreInfoModal";


export function handleMoreInfoLinks() {
    $('body').on('click', '.js-more-info-popup', function (event) {
        event.preventDefault();

        let title = $(this).data('title');
        let description = $(this).data('description');
        let data = { title, description };

        console.log(data);
        (new MoreInfoModal(data)).show();

        return false;
    }).on('click', '.js-modal-close', function () {
        $(this).parents('.modal').remove();
        $('body').removeClass('modal-active');
        return false;
    });
}
